import { action } from 'satcheljs';
import type { ScenarioSettings, ScenarioType } from 'owa-scenario-settings-service';
import type { MailboxInfo } from 'owa-client-types';

export type WORKLOAD_SCENARIO_SETTINGS_LOADEDActionMessage = {
    settings: ScenarioSettings;
    mailboxInfo: MailboxInfo;
    /** Scenario captured before the async fetch — may differ from current workload at fire time. */
    scenario: ScenarioType | undefined;
};
export const workloadScenarioSettingsLoaded: (
    settings: ScenarioSettings,
    mailboxInfo: MailboxInfo,
    scenario: ScenarioType | undefined
) => WORKLOAD_SCENARIO_SETTINGS_LOADEDActionMessage = action(
    'WORKLOAD_SCENARIO_SETTINGS_LOADED',
    (
        settings: ScenarioSettings,
        mailboxInfo: MailboxInfo,
        scenario: ScenarioType | undefined
    ): WORKLOAD_SCENARIO_SETTINGS_LOADEDActionMessage => ({
        settings,
        mailboxInfo,
        scenario,
    })
);

interface LOADING_WORKLOAD_SCENARIO_SETTINGS_FAILEDActionMessage {
    mailboxInfo: MailboxInfo;
}
export const loadingWorkloadScenarioSettingsFailed: (
    mailboxInfo: MailboxInfo
) => LOADING_WORKLOAD_SCENARIO_SETTINGS_FAILEDActionMessage = action(
    'LOADING_WORKLOAD_SCENARIO_SETTINGS_FAILED',
    (mailboxInfo: MailboxInfo): LOADING_WORKLOAD_SCENARIO_SETTINGS_FAILEDActionMessage => ({
        mailboxInfo,
    })
);
